import constants from "./constants";
import {
  fetchApi,
  fundFusionValidationFetch,
  validationFetch,
  fetchAPIFromBaseURL,
  createFormEncodedData,
} from "./helpers";
import ninVerificationResponse from "../config/ninVerificationResponse.json";

const login = (body) => fetchApi("/Account/Login", body, "POST");

const getCurrentUserRoles = (body, Authorization) =>
  fetchApi(
    `/Account/GetCurrentUserRoles?username=${body.username}`,
    null,
    "GET",
    { Authorization }
  );

const register = (body) => fetchApi("/Account/Register", body, "POST");

const logout = async (body = {}, Authorization) =>
  await fetchApi("/Account/Logout", body, "POST", { Authorization });

const allMemberBalance = (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/AllMemberBalance?pin=${body.pin}&endDate=${body.endDate}`,
    null,
    "POST",
    { Authorization }
  );

const retirementSumCalculator = (body = {}) =>
  fetchApi("/PensionCalculator/RetirementSumCalculator", body, "POST");

const capitalSumCalculator = (body = {}) =>
  fetchApi("/PensionCalculator/CapitalRecoveryCalculator", body, "POST");

const contactInfo = () => fetchApi("/ContactUs/Contact", null, "GET");
const getAllEmployers = () =>
  fetchApi("/ContactUs/GetAllEmployers", null, "GET");

const fetchFaq = async () => await fetchApi("/ContactUs/FAQ", null, "GET");

const fetchProfile = (body, Authorization) =>
  fetchApi(`/Profile/CurrentUserProfile?pin=${body.pin}`, null, "POST", {
    Authorization,
  });

const fetchCurrentPrice = (body, Authorization) =>
  fetchApi(`/Prices/GetCurrentFundPrice?fundId=${body.fundId}`, null, "GET", {
    Authorization,
  });

const fetchPriceByDateRange = (body, Authorization) =>
  fetchApi(
    `/Prices/GetFundPriceByDateRange?fundId=${body.fundId}&startDate=${body.startDate}&endDate=${body.endDate}`,
    null,
    "GET",
    {
      Authorization,
    }
  );

const fetchAllFundNames = () =>
  fetchApi(`/Prices/GetAllFundNames`, null, "GET");

const BenefitApplicationStatus = async (body = {}, Authorization) =>
  await fetchApi(
    `/SelfService/BenefitApplicationStatus?pin=${body.pin}`,
    null,
    "POST",
    { Authorization }
  );

const fetchAllDownloadableForm = () =>
  fetchApi("/Downloads/GetAllDownloadableForm", null, "POST");

const downloadForm = (body = {}, Authorization) =>
  fetchApi(
    `/Downloads/DownloadForm?documentIds=${body.documentIds}`,
    null,
    "POST",
    { Authorization }
  );

const fetchEnrollmentCertificate = async (body = {}, Authorization) =>
  await fetchApi(
    `/SelfService/MyEnrollmentCert?rsapin=${body.pin}`,
    null,
    "POST",
    { Authorization }
  );

const fetchEmployeeDetails = async (body = {}, Authorization) =>
  await fetchApi(
    `/Profile/GetEmployerDetail?employerCode=${body.employerCode}`,
    null,
    "POST",
    { Authorization }
  );

const fetchMemberContributions = async (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/MemberContribution?pin=${body.rsaPin}&startDate=${body.startDate}&endDate=${body.endDate}`,
    null,
    "POST",
    { Authorization }
  );
const fetchNextOfKinDetails = async (body = {}, Authorization) =>
  fetchApi(`/Profile/CurrentUserNextOfKin?pin=${body.pin}`, null, "POST", {
    Authorization,
  });

const fetchMemberBalance = async (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/MemberBalance?pin=${body.pin}&endDate=${body.endDate}`,
    null,
    "POST",
    { Authorization }
  );

const fetchMemberMandatoryBalance = async (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/MemberMandatoryBalance?pin=${body.pin}&endDate=${body.endDate}`,
    null,
    "POST",
    { Authorization }
  );

const fetchMemberVoluntaryContributionBalance = async (
  body = {},
  Authorization
) =>
  fetchApi(
    `/AccountInfo/MemberVoluntaryContributionBalance?pin=${body.pin}&endDate=${body.endDate}`,
    null,
    "POST",
    { Authorization }
  );

const changePassword = async (body = {}, Authorization) =>
  fetchApi(`/Account/ChangePassword`, body, "POST", { Authorization });

const getAllRoles = () => fetchApi("/Account/GetAllRoles", null, "GET");

const userRole = async (body = {}, Authorization) =>
  fetchApi(
    `/Account/AddUserRole?updateField=${body.code}`,
    body.userRole,
    "POST",
    { Authorization }
  );

const fetchPrivacyPolicy = async () =>
  fetchApi(`/Privacy/Clause`, null, "POST");

const fetchConsent = async () => fetchApi(`/Privacy/NDPRConsent`, null, "POST");

const acceptConsent = async (body = {}, Authorization) =>
  fetchApi(
    `/Account/PostNDPRTermAcceptance?username=${body.userName}&ndprStatus=${body.isAccepted}`,
    null,
    "POST",
    { Authorization }
  );

const isConsentAccepted = async (body = {}, Authorization) =>
  fetchApi(
    `/Account/IsNDPRTermAccepted?userName=${body.userName}`,
    null,
    "POST",
    { Authorization }
  );

const fetchFormReferenceNo = async () =>
  fetchApi(`/OnBoarding/GenerateNewFormReference`, null, "POST");

const fetchAllSectors = async () =>
  fetchApi(`/Onboarding/GetAllSector`, null, "GET");

const getUsernameAndPassword = async (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/MicroPensionCredentials?userName=${body.userName}`,
    null,
    "POST",
    { Authorization }
  );

const getUsernameAndPasswordUBA = async (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/MicroPensionCredentialsUBA?userName=${body.userName}`,
    null,
    "POST"
  );

const validation = async (body = {}, header) =>
  validationFetch("/micropension/validate/bypin", body, "POST", header);

const contribution = async (body = {}, header) =>
  validationFetch("/micropension/contribution/new", body, "POST", header);

const withdrawal = async (body = {}, header) =>
  validationFetch("/micropension/withdrawal/new", body, "POST", header);

const onBoardingSubmit = async (body = {}, header) =>
  validationFetch("/micropension/onboarding/submit", body, "POST", header);

const sendRegisterationNotification = async (body = {}, Authorization) => {
  const queryObject = `userEmail=${body.userEmail}&firstName=${body.firstName}&nin=${body.nin}&phone=${body.phone}`;

  if (!Authorization) {
    fetchApi(
      `/OnBoarding/SendRegistrationNotification?${queryObject}`,
      null,
      "POST"
    );
  } else {
    fetchApi(
      `/OnBoarding/SendRegistrationNotification?${queryObject}`,
      null,
      "POST",
      {
        Authorization,
      }
    );
  }
};

const RSAPinSubmit = async (body = {}, header) =>
  validationFetch("/regmodule-ecrs/onboarding", body, "POST", header);

const getBaseURLandPublicToken = () =>
  fetchApi("/NINONlineReg/GetBaseURL", null, "GET");

const verifyNIN = (body, headers, baseURL) => {
  if (constants.isNINVerificationAPIConnected) {
    const payload = {
      method: "POST",
      path: "/api/verifyNIN",
      body: body,
      headers: headers,
      baseURL: baseURL,
    };

    return fetchAPIFromBaseURL(payload);
  } else {
    //eslint-disable-next-line
    if (body.nin != ninVerificationResponse.data.nin) {
      throw new Error("");
    }
    return ninVerificationResponse;
  }
};

const publicRSAPinSubmit = async (body = {}, header) =>
  fundFusionValidationFetch("/regmodule-ecrs/onboarding", body, "POST", header);

const fetchStaffData = async (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/StaffDashboard?staffCode=${body.staffCode}`,
    null,
    "POST",
    { Authorization }
  );

const fetchEmployerData = async (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/EmployerDashboard?employerCode=${body.employerCode}`,
    null,
    "POST",
    { Authorization }
  );

const fetchAgentData = async (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/AgentDashboard?agentCode=${body.agentCode}`,
    null,
    "POST",
    { Authorization }
  );

const fetchCountries = async () =>
  fetchApi(`/Location/GetAllCountry`, null, "POST");

const getAllPFAs = async () => fetchApi(`/Location/GetAllPFAs`, null, "POST");

const fetchState = async (body = {}, Authorization) =>
  fetchApi(
    `/Location/GetStatesForCountry?countryCode=${body.countryCode}`,
    null,
    "POST",
    { Authorization }
  );

const fetchLGA = async (body = {}, Authorization) =>
  fetchApi(
    `/Location/GetLGAsForState?stateCode=${body.stateCode}`,
    null,
    "POST",
    { Authorization }
  );

const getMyStatement = async (body = {}, Authorization) =>
  fetchApi(
    `/SelfService/GetMyStatement?pin=${body.pin}&sDate=${body.sDate}&eDate=${body.eDate}`,
    null,
    "POST",
    { Authorization }
  );

const getTermsAndCondition = async () =>
  fetchApi(`/Referral/TermsAndCondition`, null, "POST");

const getRelationships = async () =>
  fetchApi(`/OnBoarding/GetAllRelationship`, null, "GET");

const createReferral = async (body = {}, Authorization) =>
  fetchApi(`/Referral/New`, body, "POST", { Authorization });

const getAllBanks = async () => fetchApi(`/Referral/GetAllBanks`, null, "GET");

const getBankDetails = async (body, Authorization) =>
  fetchApi(`/Referral/GetBankDetails?userName=${body.userName}`, null, "GET", {
    Authorization,
  });

const redemption = async (body, Authorization) =>
  fetchApi(
    `/Referral/Redemption?referredBy=${body.referredBy}&currentPointRedeemed=${body.currentPointRedeemed}&transactionType=${body.transactionType}`,
    null,
    "GET",
    {
      Authorization,
    }
  );

const getReferralReportReward = async (body = {}, Authorization) =>
  fetchApi(
    `/Referral/GetReferralRewardReport?sDate=${body.sDate}&eDate=${body.eDate}&transactionType=${body.transactionType}&referredBy=${body.referredBy}`,
    null,
    "GET",
    {
      Authorization,
    }
  );

const getReferralDashboard = async (body = {}, Authorization) =>
  fetchApi(
    `/Referral/GetReferralDashboard?userName=${body.userName}`,
    null,
    "GET",
    {
      Authorization,
    }
  );

const getMyReferrals = async (body = {}, Authorization) =>
  fetchApi(
    `/Referral/GetMyReferralsReport?sDate=${body.sDate}&eDate=${body.eDate}`,
    null,
    "GET",
    {
      Authorization,
    }
  );

const forgotPassword = async (body = {}) =>
  fetchApi(
    `/Account/ForgotPassword?username=${body.username}&smsOrEmail=${body.smsOrEmail}`,
    null,
    "POST"
  );

const forgotPasswordUsername = async (body = {}) => {
  const qs = createFormEncodedData(body);

  return fetchApi(`/Account/ForgotUsername?${qs}`, null, "POST");
};

const newPassword = async (body = {}) => {
  const qs = createFormEncodedData(body);

  return fetchApi(
    `/Account/ExecuteForgotPasswordWithNewPass?${qs}`,
    null,
    "POST"
  );
};

const requestEmployerPencomEmployerCode = async (body = {}, Authorization) =>
  fetchApi(`/Employer/RequestEmployerPencomEmployerCode`, body, "POST", {
    Authorization,
  });

const custInformationUpdate = async (body = {}, Authorization, pin) =>
  fetchApi(`/Profile/CustInformationUpdate?pin=${pin}`, body, "POST", {
    Authorization,
  });

const getAccountOfficer = async (body = {}, Authorization) =>
  fetchApi(`/Profile/GetAccountOfficer?pin=${body.pin}`, null, "GET", {
    Authorization,
  });

const ScheduleUpload = async (body = {}, Authorization) =>
  fetchApi(
    `/Employer/Sheduleupload`,
    body,
    "POST",
    {
      Authorization,
    },
    true
  );

const submittedScheduleReport = async (body = {}, Authorization) =>
  fetchApi(
    `/Employer/SubmittedScheduleReport?employerCode=${body.employerCode}&startDate=${body.startDate}&endDate=${body.endDate}`,
    null,
    "POST",
    {
      Authorization,
    }
  );

const scheduleReport = async (body = {}, Authorization) =>
  fetchApi(
    `/Employer/ScheduleReport?employerCode=${body.employerCode}&startDate=${body.startDate}&endDate=${body.endDate}`,
    null,
    "POST",
    {
      Authorization,
    }
  );

const employerDashboardFinancial = async (body = {}, Authorization) =>
  fetchApi(
    `/AccountInfo/EmployerDashboardFinancial?employerCode=${body.employerCode}`,
    null,
    "POST",
    {
      Authorization,
    }
  );

const sendInterestedProspect = (body = {}, Authorization) => {
  return fetchApi(`/TransferWindow/InterestedProspect`, body, "POST", {
    Authorization,
  });
};

const MPPContributionCallback = (body = {}) => {
  return fetchApi(`/Payment/MPPContributionCallback`, body, "POST");
};

const verifyActivationToken = async (body = {}) => {
  const qs = createFormEncodedData(body);

  return fetchApi(`/Verify/ActivationToken?${qs}`, null, "POST");
};

const getActivationStatus = (body) => {
  const qs = createFormEncodedData(body);

  return fetchApi(`/Account/GetActivationStatus?${qs}`, null, "GET");
};

const regActivation = (body) => {
  const qs = createFormEncodedData(body);

  return fetchApi(`/Account/RegActivation?${qs}`, null, "POST");
};

export default {
  login,
  getCurrentUserRoles,
  register,
  logout,
  allMemberBalance,
  retirementSumCalculator,
  capitalSumCalculator,
  contactInfo,
  getAllEmployers,
  fetchFaq,
  fetchProfile,
  fetchCurrentPrice,
  fetchPriceByDateRange,
  fetchAllFundNames,
  BenefitApplicationStatus,
  fetchAllDownloadableForm,
  downloadForm,
  fetchEnrollmentCertificate,
  fetchEmployeeDetails,
  fetchNextOfKinDetails,
  fetchMemberMandatoryBalance,
  fetchMemberVoluntaryContributionBalance,
  fetchMemberBalance,
  fetchMemberContributions,
  changePassword,
  getAllRoles,
  userRole,
  fetchPrivacyPolicy,
  fetchConsent,
  isConsentAccepted,
  acceptConsent,
  getUsernameAndPassword,
  validation,
  contribution,
  withdrawal,
  fetchStaffData,
  onBoardingSubmit,
  fetchAllSectors,
  fetchEmployerData,
  fetchAgentData,
  fetchCountries,
  fetchState,
  fetchLGA,
  getMyStatement,
  RSAPinSubmit,
  sendRegisterationNotification,
  getTermsAndCondition,
  createReferral,
  getAllBanks,
  getBankDetails,
  getReferralReportReward,
  redemption,
  getReferralDashboard,
  getMyReferrals,
  getRelationships,
  forgotPassword,
  newPassword,
  fetchFormReferenceNo,
  requestEmployerPencomEmployerCode,
  custInformationUpdate,
  getAccountOfficer,
  ScheduleUpload,
  submittedScheduleReport,
  scheduleReport,
  employerDashboardFinancial,
  getUsernameAndPasswordUBA,
  getAllPFAs,
  sendInterestedProspect,
  MPPContributionCallback,
  publicRSAPinSubmit,
  getBaseURLandPublicToken,
  verifyNIN,
  verifyActivationToken,
  getActivationStatus,
  regActivation,
  forgotPasswordUsername,
};
